import { profile, axiosConfig } from 'api';

import { CreateResellerModel } from 'models/createResellerForm';
import { Response } from 'models/response';
import { MyThunkResult } from 'store';


export const saveReseller = async (createResellerForm): Promise<CreateResellerModel> => {
  try {
      return await (
        await profile.post<Response<CreateResellerModel>>('Company/CreateResellerCompany', createResellerForm)
      ).data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const saveResellerCompany =
  (config: CreateResellerModel): MyThunkResult<Promise<any | undefined>> =>
  async (dispatch) => {
    try {
      //dispatch(companyConfigurationRequest());
      const { data } = await profile.post<Response<any>>('Company/CreateResellerCompany',  config,
        axiosConfig,
      );
      return data.data;
    } catch (ex) {

      //dispatch(companyConfigurationError(ex));
      alert('error on save Reseller Company');
      return undefined;
    }
  };
